import React from "react";
import ReactDOM from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import App from "./App";
import { captureSessionEntry } from "./lib/profile-traffic";
import "./index.css";
// Last, so the design system wins ties with older page stylesheets.
import "./styles/foundation.css";

// Before the router runs: remember how this session reached PulseBoard
// (search, social, referral, direct) for first-party profile traffic.
captureSessionEntry();

const rootEl = document.getElementById("root");
if (!rootEl) {
  throw new Error("#root not found in index.html");
}

ReactDOM.createRoot(rootEl).render(
  <React.StrictMode>
    <HelmetProvider>
      <App />
    </HelmetProvider>
  </React.StrictMode>,
);
